var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-icon',{attrs:{"icon":"storefront","size":"1.5rem"}})}
var staticRenderFns = []

export { render, staticRenderFns }